import { render, staticRenderFns } from "./PermissionUpsert.vue?vue&type=template&id=c783934a&scoped=true"
import script from "./PermissionUpsert.vue?vue&type=script&lang=js"
export * from "./PermissionUpsert.vue?vue&type=script&lang=js"
import style0 from "./PermissionUpsert.vue?vue&type=style&index=0&id=c783934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c783934a",
  null
  
)

export default component.exports